import React, { Component } from "react";
import { Form, Input, Upload, Icon, Radio, Switch, Tooltip } from "antd";
import { connect } from "react-redux";
import * as _ from 'lodash';
import style from "./list.module.sass";
import { createApps, updateApps, updateAppBranch } from "../../stateManager/store/apps/actions";
import { setStepIndex, setGuideVisible, setOnboardingAppDetails } from "../../stateManager/store/onboarding/action";

import { Http } from "../../helpers/axois";
import { APIURL, GCPENDPOINT } from "../../constant/common";
import { pushToast } from '../../stateManager/store/toast/actions';
import { ReactComponent as Info } from "../../assets/svg/info.svg";
import { updateOnboarding } from "../../helpers/onboardingHelper";
import { ReactComponent as BrokenImage_Icon } from "../../assets/svg/BrokenImage_Icon.svg";


const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 }
  }
};

function getBase64(img: any, callback: any) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

interface IsValidImage {
  [key: string]: boolean;
}

interface State {
  loading?: boolean;
  imageUrl?: any;
  imageObj?: any;
  appName?: string;
  displayName?: string;
  appType?: string | null;
  organization?: string;
  organizationList?: any[];
  team?: any,
  teamList?: any[],
  isValidImage: IsValidImage;
  chatType?: "genai" | "nlp"
}

type initialdata = State & { appId?: string }

interface Props {
  onSubmit: (submit: (setvisible: (status: boolean) => void) => void) => void;
  getApps: (id?: string) => void;
  createApps?: (data: any) => void;
  editable?: boolean;
  initialdata?: initialdata;
  updateApps?: (data: any) => void;
  selectedOrg?: any;
  pushToast?: (data: any) => void;
  cancelText?: string;
  okText?: string;
  onCancel?: (data: any) => void;
  stepIndex: number;
  setStepIndex: (data: any) => void;
  guideVisible: boolean;
  setOnboardingAppDetails: (data: any) => void;
  setGuideVisible: (data: any) => void;
  updateAppBranch: (data: any) => void;
  userName: string;
  stageIndex: number;
  onboardingInfo: any;
  userDetails: {
    tenantId: string,
    userId: string,
  }
}

class App extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      loading: false,
      imageUrl: "",
      displayName: '',
      appName:
        "",
      appType:
        'a8flow',
      chatType: "genai",
      organization:
        "",
      organizationList: [],
      team: [],
      teamList: [],
      isValidImage: {},
    };
    this.props.onSubmit(this.onSubmit);
  }

  componentDidMount() {
    // this.getOrganization();
    if (this.props.editable) {
      this.getApp(this.props.initialdata!.appId);
    }
  }

  getApp(id?: string) {
    const stepIndex = this.props.stepIndex;
    if (this.props.guideVisible) {
      this.props.setStepIndex(stepIndex + 1)
    }
    Http.get(`org/${this.props.selectedOrg.id}/apps/${id}`).subscribe((appRes: any) => {
      if (_.size(appRes) > 0) {
        const appData = appRes[0];
        // this.getTeams(appData.orgId, appData);
        
        this.setState({
          appName: appData.name,
          displayName: appData.displayName,
          appType: appData.type,
          organization: appData.orgId,
          imageUrl: appData.avatar,
          chatType: appData.chat_type
        })
        if (this.props.guideVisible && appRes) {
          const payload = {
            ...this.props.onboardingInfo,
            stepIndex: stepIndex + 1,
            stageIndex: this.props.stageIndex,
            appId: appRes[0].appId,
            appType: appRes[0].type
          }
          updateOnboarding(this.props.userName, payload) 
          this.props.updateAppBranch({
            key: appRes[0].appId,
            value: {
              branchName:  appRes[0].branches && appRes[0].branches[0] && appRes[0].branches[0]["f2"],
              branchId: appRes[0].branches && appRes[0].branches[0] && appRes[0].branches[0]["f1"]
            }
          })
        }
        
      }
    },
    (err) => {
      if (this.props.guideVisible) {
        this.props.setGuideVisible(false)
      }
    });
  }

  // getOrganization() {
  //   Http.get('orgs/list').subscribe((res: any) => {
  //     this.setState({
  //       organizationList: res
  //     })
  //   })
  // }

  // getTeams(orgId: string, appData?: any) {
  //   Http.get(`teams/list/${orgId}`).subscribe((res: any) => {
  //     if (appData) {
  //       this.setState({
  //         teamList: res,
  //         team: (appData.teamId === null) ? undefined : appData.teamId,
  //       })
  //     } else {
  //       this.setState({
  //         teamList: res
  //       })
  //     }
  //   })
  // }


  handleChange = _.debounce(async (info: any) => {
    this.setState({
      loading: true,
    });

    if (info.file.originFileObj) {
      try {
        const formData = new FormData();
        const appId = this.props.initialdata?.appId;
        formData.append("file", info.file.originFileObj);
        const response: any = await Http.post(`${APIURL}orgs/${this.props.selectedOrg.id}/apps/Appimage/upload`, formData).toPromise();

        if (response) {
          this.setState({
            imageUrl: response.url, 
            imageObj: info.file.originFileObj,
            isValidImage: {
              [appId!]: true,
            },
          });
        } else {
          this.props.pushToast && this.props.pushToast({ type: 'error', message: 'Failed to upload image!' });
          this.setState({ loading: false });
        }
      } catch (error) {
        console.error("Error uploading image:", error);
        this.props.pushToast && this.props.pushToast({ type: 'error', message: 'Failed to upload image!' });
        this.setState({ loading: false });
      }
    }
    this.setState({
      loading: false,
    });
  }, 500);
  

  beforeUpload = (file: any) => {
    this.setState({ loading: true });
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      this.props.pushToast && this.props.pushToast(
        { type: 'error', message: 'You can only upload JPG/PNG file!' }
      )
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      this.props.pushToast && this.props.pushToast(
        { type: 'error', message: 'Image must smaller than 2MB!' }
      )
      return false;
    }

    getBase64(file, (imageUrl: any) =>
      this.setState({
        imageUrl: imageUrl,
        imageObj: file,
        loading: true
      })
    );
    return isJpgOrPng && isLt2M;
  }
  onSubmit = (setvisible: (status: boolean) => void) => {
    const { editable } = this.props;
    const formData = new FormData();
    this.state.imageUrl && formData.append("avatar", this.state.imageUrl);
    formData.append("name", this.state.appName!);
    formData.append("type", this.state.appType!);
    formData.append("orgId", this.props.selectedOrg.id);
    formData.append("displayName", this.state.displayName!);
    if (this.state.appType === "a8chat") {
      formData.append("chatType", this.state.chatType!);
    }
    this.state.team && formData.append("teamId", this.state.team!);

    if (!editable) {
      // this.props.createApps!({ id: uuidv4(), ...this.state });
      // if (this.state.appName && this.state.appType && this.state.organization && this.state.displayName) {
      if (this.state.appName && this.state.displayName) {
        this.saveApps(formData, setvisible);
      }
    } else {
      let { appId } = this.props.initialdata!;
      // this.props.updateApps!({ id: id, ...this.state });
      // if (this.state.appName && this.state.appType && this.state.organization && this.state.displayName) {
      if (this.state.appName && this.state.displayName) {
        if (appId) {
          this.updateApps(appId, formData, setvisible);
        }
      }
    }
  };

  saveApps(formData: any, setvisible: (status: boolean) => void) {
    Http.post('apps', formData).subscribe((res: any) => {
      const id = res[0].app_id;
      this.props.getApps(res[0].app_id);
      this.props.pushToast && this.props.pushToast(
        { type: 'success', message: 'App created successfully' }
        )
      if (this.props.guideVisible) {  
        this.getApp(res[0].app_id)
      }
      setvisible(false);
      this.setState({
        isValidImage: {
          [id]: true,
        },
      })
    }, (err) => {
      this.props.pushToast && this.props.pushToast(
        { type: 'error', message: (err && err.message) ? err.message : 'App creation failed' }
      )
      setvisible(false);
      this.props.setGuideVisible(false);
    });
  }

  updateApps(id: string, formData: any, setvisible: (status: boolean) => void) {
    Http.put(`apps/${id}`, formData).subscribe((res) => {
      this.props.getApps();
      this.props.pushToast && this.props.pushToast(
        { type: 'success', message: 'App updated successfully' }
      )
      setvisible(false);
      this.setState({
        isValidImage: {
          [id]: true,
        },
      })
    }, (err) => {
      this.props.pushToast && this.props.pushToast(
        { type: 'error', message: (err && err.message) ? err.message : 'App updation failed' }
      )
      setvisible(false);
    })
  }

  handleImageError = (id: string | undefined) => {
    if (id !== undefined) {
      this.setState((prevState) => ({
        loading: false,
        isValidImage: {
          ...prevState.isValidImage,
          [id]: false,
        },
      }));
    }
  };

  handleImageLoad = (id: string | undefined) => {
    if (id !== undefined) {
      this.setState((prevState) => ({
        loading: false,
        isValidImage: {
          ...prevState.isValidImage,
          [id]: true,
        },
      }));
    }
  };


  render() {
    // const { editable, initialdata } = this.props;
    // const { imageUrl, appName, appType, organization, displayName } = this.state;
    const { imageUrl, appName, displayName, appType } = this.state;
    const appId = this.props.initialdata?.appId;
    const uploadButton = (
      <div>
        <Icon data-test-id="upload" type={this.state.loading ? "loading" : "plus"} />
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    return (
      <>
      <div style={{padding: 10}}>
        <Form {...formItemLayout} className={style.app + ' override-content'}>
          <Form.Item className="tour_create_app_name_step" required label={<span className={style.labelName}>Display Name</span>}>
            <Input
              data-test-id="display_name"
              value={
                displayName 
              }
              className="app_name_input"
              onKeyDown={(e: React.KeyboardEvent) => {
                if (this.props.guideVisible && e.key === 'Tab') {
                  e.preventDefault();
                }
              }}
              onChange={e => {
                const re = /^[A-Za-z_][A-Za-z0-9,_/;'"!&@%$-\s]*$/;                               ;
                if (e.target.value === '' || re.test(e.target.value)) {
                  let val =  e.target.value.replace(/[^a-zA-Z0-9_ ]/g, "") 
                 let value =  val.replace(/ /g,"_") 
                  this.setState({ displayName: e.target.value, appName: this.props.editable ? this.state.appName :value} )
                }
            }}
            />
          </Form.Item>
          <Form.Item required label={<span className={style.labelName}>Name (identifier)</span>}>
            <Input
              disabled={this.props.editable}
              data-test-id="app_name"
              value={
                appName
              }
              onChange={e =>{const re = /^[A-Za-z_][A-Za-z0-9_]*$/;
              if (e.target.value === '' || re.test(e.target.value)) {
                 this.setState({ appName: e.target.value.trim().replace(/ /g, "_") })}}}
            />
          </Form.Item>
          <Form.Item className="tour_apptype_step" required label={<span className={style.labelName}>App Type</span>}>
            <Radio.Group
              disabled={this.props.editable}
              data-test-id="radio_app_type"
              value={
                appType
              }
              onChange={e => this.setState({ appType: e.target.value })}
            >
              <Radio 
                
                onKeyDown={
                  (e: React.KeyboardEvent) => {
                     if(this.props.guideVisible && e.key === 'Tab') {
                      e.preventDefault()
                    }
                }} 
                disabled={this.props.guideVisible}
                data-test-id="a8solo" 
                value={'a8solo'}>
                <span>A8Solo</span>
              </Radio>
              <Radio 
                data-test-id="a8flow" 
                value={'a8flow'}
                onKeyDown={
                  (e: React.KeyboardEvent) => {
                     if(this.props.guideVisible && e.key === 'Tab') {
                      e.preventDefault()
                    }
                }} 
              >
                <span>A8Flow</span>
              </Radio>
              <Radio 
                disabled={this.props.guideVisible} 
                data-test-id="a8chat" 
                value={'a8chat'}
                onKeyDown={
                  (e: React.KeyboardEvent) => {
                     if(this.props.guideVisible && e.key === 'Tab') {
                      e.preventDefault()
                    }
                }} 
              >
                <span>A8Chat</span>
              </Radio>
            </Radio.Group>
          </Form.Item>
          {appType === "a8chat" && 
            <div style={{display: "flex", width: "100%", padding: "5px 20px", justifyContent: "space-between"}} >
              <div style={{display: "flex", alignItems: "center", gap: "5px", color: "#292D32"}}><span className={style.labelName}>Use Legacy NLP</span>
                <Tooltip title={this.state.chatType === "genai" ? 'GenAI for flexible, context-rich output.': 'Legacy NLP for controlled, predictable output.'} placement='bottom' overlayClassName='propertiesPopUp'>
                  <Info/>
                </Tooltip>
              </div>
              <div>
                 <Switch disabled={this.props.editable} checked={this.state.chatType !== 'genai'} onChange={e => this.setState({ chatType: e ? "nlp" : "genai" })}  />
              </div>
            </div>}
          {/* <Form.Item required
            label={<span className={style.labelName}>Organization</span>}
          >

            <Select
              data-test-id="select_org"
              showSearch
              placeholder="Select an Organization"
              optionFilterProp="children"
              value={organization}
              onChange={(e: any) => {
                // this.getTeams(e.toString());
                this.setState({ organization: e.toString() })
              }}
              filterOption={(input, option) =>
                (option && option.props && option.props.children) ? option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 : false
              }
            >
              {
                this.state.organizationList && this.state.organizationList.map((list, key) => {
                  return (<Option data-test-id={`org_${list.orgName}`} value={list.id} key={key}>{list.orgName}</Option>)
                })
              }
            </Select>
          </Form.Item> */}
          {/* <Form.Item
            label={<span className={style.labelName}>Teams</span>}
          >
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Please select teams"
              disabled={this.state.teamList!.length === 0}
              onChange={(e: any) => { this.setState({ team: e }) }}
              value={team}
            >
              {this.state.teamList && this.state.teamList.map((list, key) =>
                <Option value={list.id} key={key}>{list.teamName}</Option>
              )}
            </Select>

          </Form.Item> */}
          <Form.Item
            label={<span className={style.labelName}>Avatar</span>}>
            <Upload
              data-test-id="avatar"
              name="avatar"
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={this.beforeUpload}
              onChange={this.handleChange}
              customRequest={()=>{}}
            >
                {imageUrl ? (
                  <>
                    {this.state.loading ? (
                      <Icon data-test-id="upload" type={this.state.loading ? "loading" : "plus"} />
                    ) : (
                      this.state.isValidImage[appId!] !== false ?
                        <img
                          src={`${imageUrl.startsWith("https://") ? imageUrl : GCPENDPOINT+imageUrl}`}
                          alt="Avatar"
                          style={{ width: "100%" }}
                          onLoad={() => {                    
                            this.handleImageLoad(appId);
                          }}
                          onError={() => {
                            this.handleImageError(appId);
                          }}
                        />
                        :
                        <BrokenImage_Icon />
                    )}
                  </>
                ) : (
                  uploadButton
                )}
            </Upload>
          </Form.Item>
        </Form>
      </div>
       <div  style={{padding: 10, borderTop: '1px solid #d9d9d9'}} className={" flex justify-end gap-8 " + style.app_creation_footer}>
        <button onClick={this.props.onCancel} className={style.cancel}>{this.props.cancelText}</button>
        <button onClick={() => { this.props.onSubmit(this.onSubmit) }} style={{ background: "#15808C"}} className={`${style.create}  tour_app_creation_step`} disabled={this.state.loading}>{this.props.okText}</button>
     </div>
     </>
    );
  }
}

const mapStateToProps = (state: any, props: any) => {
  return {
    selectedOrg: state.org.selectedOrg,
    stepIndex: state.onboarding.info.stepIndex,
    stageIndex: state.onboarding.info.stageIndex,
    guideVisible: state.onboarding.guideVisible,
    onboardingInfo: state.onboarding.info,
    userName: state.user.data.user.userName,
    userDetails: state.user.userDetails
  };
};

export default connect(
  mapStateToProps,
  { createApps, updateApps, pushToast, setStepIndex, setGuideVisible, updateAppBranch, setOnboardingAppDetails }
)(App);
